import produce from 'immer'
import { clone } from 'lodash'
import { LoadedValueType, ODEntityEditorContextActionType } from './action'
export var ODEntityState
;(function (ODEntityState) {
  ODEntityState['LoadingInitial'] = 'LoadingInitial'
  ODEntityState['LoadingInitialError'] = 'LoadingInitialError'
  ODEntityState['LoadedInitialForCreation'] = 'LoadedInitialForCreation'
  ODEntityState['LoadingInitialSuccess'] = 'LoadingInitialSuccess'
  ODEntityState['SavingUpdates'] = 'SavingUpdates'
  ODEntityState['SavingCreates'] = 'SavingCreates'
})(ODEntityState || (ODEntityState = {}))
//
// Context APIs
//
export function createEntityEditorReducer() {
  return function (state, action) {
    return produce(state, function (draft) {
      switch (action.type) {
        case ODEntityEditorContextActionType.TYPE_SET_LOADING:
          draft.loading = action.loading
          break
        case ODEntityEditorContextActionType.TYPE_VALUE_LOADED:
          draft.state =
            action.loadedValueType === LoadedValueType.InitialCreating
              ? ODEntityState.LoadedInitialForCreation
              : ODEntityState.LoadingInitialSuccess
          draft.loading = false
          // draft.serverValue = action.serverValue as Draft<T>
          draft.clientValue = action.clientValue
          draft.initialValue = clone(action.clientValue)
          draft.initialValueLoaded = true
          break
        case ODEntityEditorContextActionType.TYPE_INITIAL_VALUE_LOAD_FAILED:
          draft.state = ODEntityState.LoadingInitialError
          draft.stateError = action.error
          draft.loading = false
          draft.initialValueLoaded = false
          break
        case ODEntityEditorContextActionType.TYPE_SET_URL_TO_REDIRECT:
          draft.urlToRedirect = action.urlToRedirect
          break
        case ODEntityEditorContextActionType.TYPE_SET_SAVING:
          draft.saving = action.saving
          // tslint:disable-next-line:prefer-conditional-expression
          if (action.isCreating) {
            draft.state = action.saving ? ODEntityState.SavingCreates : ODEntityState.LoadedInitialForCreation
          } else {
            draft.state = action.saving ? ODEntityState.SavingUpdates : ODEntityState.LoadingInitialSuccess
          }
          break
        case ODEntityEditorContextActionType.TYPE_SET_DELETING:
          draft.deleting = action.deleting
          break
        case ODEntityEditorContextActionType.TYPE_MODIFY_CLIENT_VALUE:
          action.modifyInPlace(draft.clientValue)
          break
        default:
          break
      }
    })
  }
}
export function createInitialReducerState() {
  return {
    state: ODEntityState.LoadingInitial,
    stateError: null,
    loading: true,
    initialValueLoaded: false,
    clientValue: null,
    initialValue: null,
    urlToRedirect: null,
    saving: false,
    deleting: false,
  }
}
//# sourceMappingURL=reducer.js.map
